module.exports = __webpack_public_path__ + "img/pos--icon.5a27d3d3.svg";